/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
import * as _preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import adSchedulingOptions from '@bingads-webui-campaign-legacy/ad-schedule/viewmodel/options';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import * as bidAdjustmentUtils from '@bingads-webui-campaign/target-bid-adjustment';
import pageContext from '@bingads-webui-static-legacy/page-context';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var preferencesService = _preferencesService.default || _preferencesService;
var calculateBidAdjustment = function calculateBidAdjustment(type, amount) {
  if ((type == 1 || type == -1) && _.isFinite(amount)) {
    return type * amount;
  }
  return false;
};
var cloneRange = function cloneRange(range) {
  return {
    Id: range.Id,
    Day: range.Day(),
    StartHour: range.StartHour(),
    StartMinute: range.StartMinute(),
    EndHour: range.EndHour(),
    EndMinute: range.EndMinute(),
    BidAdjustmentType: _.isUndefined(range.BidAdjustmentType()) ? 1 : range.BidAdjustmentType(),
    BidAdjustmentAmount: _.isUndefined(range.BidAdjustmentAmount()) ? 0 : range.BidAdjustmentAmount(),
    CashbackPercent: _.isUndefined(range.CashbackPercent()) ? null : range.CashbackPercent()
  };
};
var isDefaultRange = function isDefaultRange(range, supportCashbackSettings) {
  var rangeObj = range();
  return rangeObj.Day() === 'AllDays' && rangeObj.StartHour() == 0 && rangeObj.StartMinute() === 'ZERO' && rangeObj.EndHour() == 24 && rangeObj.EndMinute() === 'ZERO' && rangeObj.BidAdjustmentAmount() == 0 && (supportCashbackSettings ? rangeObj.CashbackPercent() === '' || rangeObj.CashbackPercent() === null || rangeObj.CashbackPercent() === undefined : true);
};
var logInteraction = _.once(function () {
  if (this.activityLogger) {
    this.activityLogger.signal('campaign day time range changed', 'ad schedule');
  }
}, this);
var produceDayTimeObservable = function produceDayTimeObservable(callOnChangeCb, rawRange, isCampaignDayTimeRange) {
  var range = _.extend({}, {
    Id: '',
    Day: 'Sunday',
    StartHour: 0,
    StartMinute: 'ZERO',
    EndHour: 24,
    EndMinute: 'ZERO',
    BidAdjustmentType: 1,
    BidAdjustmentAmount: 0,
    CashbackPercent: null
  }, rawRange);
  var cashbackPercentInheritInfo = bidAdjustmentUtils.getCashbackInheritOptions({
    readonly: isCampaignDayTimeRange,
    CashbackPercent: range.CashbackPercent,
    viewContext: {
      currentAdGroup: this.currentAdGroup,
      currentCampaign: this.currentCampaign
    },
    i18n: i18n
  });
  var dayTime = ko.observable({
    Id: '',
    Day: ko.observable(range.Day),
    StartHour: ko.observable(range.StartHour),
    StartMinute: ko.observable(range.StartMinute),
    EndHour: ko.observable(range.EndHour),
    EndMinute: ko.observable(range.EndMinute),
    BidAdjustmentType: ko.observable(range.BidAdjustmentType),
    BidAdjustmentAmount: ko.observable(range.BidAdjustmentAmount),
    CashbackPercent: ko.observable(range.CashbackPercent),
    InheritCashbackPercentValue: ko.observable(cashbackPercentInheritInfo.inheritValue === '-' ? '-' : decimal.fromFloatToString(cashbackPercentInheritInfo.inheritValue, 2)),
    CashbackPercentOptions: ko.observable(cashbackPercentInheritInfo.options),
    CashbackPercentSelectedOption: ko.observable(cashbackPercentInheritInfo.selected),
    CashbackPercentSnapShot: ko.observable(range.CashbackPercent)
  });
  dayTime().CashbackPercentSelectedOption.subscribe(function (currentSelectedOption) {
    if (currentSelectedOption === 'override') {
      dayTime().CashbackPercentSnapShot(dayTime().CashbackPercent());
    }
  }, dayTime(), 'beforeChange');
  dayTime().CashbackPercentSelectedOption.subscribe(function (v) {
    if (v === 'inherit') {
      dayTime().CashbackPercent(null);
    } else if (v === 'override') {
      dayTime().CashbackPercent(dayTime().CashbackPercentSnapShot());
    } else if (v === 'noCashback') {
      dayTime().CashbackPercent('0.00');
    }
  }, dayTime());
  dayTime().scheduleInRowError = ko.computed(this.conditionScheduleError, dayTime());
  dayTime().isDayTimeEditable = true;
  var self = this;
  dayTime().Day.subscribe(function () {
    logInteraction.call(self);
    callOnChangeCb();
  });
  dayTime().StartHour.subscribe(function () {
    logInteraction.call(self);
    callOnChangeCb();
  });
  dayTime().StartMinute.subscribe(function () {
    logInteraction.call(self);
    callOnChangeCb();
  });
  dayTime().EndHour.subscribe(function () {
    logInteraction.call(self);
    callOnChangeCb();
  });
  dayTime().EndMinute.subscribe(function () {
    logInteraction.call(self);
    callOnChangeCb();
  });
  dayTime().BidAdjustmentType.subscribe(function () {
    logInteraction.call(self);
    callOnChangeCb();
  });
  dayTime().BidAdjustmentAmount.subscribe(function () {
    logInteraction.call(self);
    callOnChangeCb();
  });
  return dayTime;
};
var convertDayTimeRanges = function convertDayTimeRanges(ranges, ignoreDefaultRange, supportCashbackSettings) {
  var res = [], daysMondayToFriday = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], daysAllDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  _.each(ranges, function (range) {
    if (isDefaultRange(range, supportCashbackSettings) && ignoreDefaultRange) {
      return;
    } else if (range().Day() === 'AllDays') {
      _.each(daysAllDays, function (day) {
        res.push(_.extend(cloneRange(range()), {
          Day: day
        }));
      });
    } else if (range().Day() === 'MondayToFriday') {
      _.each(daysMondayToFriday, function (day) {
        res.push(_.extend(cloneRange(range()), {
          Day: day
        }));
      });
    } else {
      res.push(cloneRange(range()));
    }
  });
  return res;
};
var ViewModel = function ViewModel(model, level, campaignDayTimeRanges, isForVNext, activityLogger, supportCashbackSettings, currentCampaign, currentAdGroup, hideAdScheduleBidAdjustments = false, readOnlyTimeZone = false, hideWarning, hideUseCampaignSetting = false, callOnChangeCb = _.identity) {
  this.model = model;
  this.isForVNext = ko.observable(isForVNext);
  this.activityLogger = activityLogger;
  this.currentAdGroup = currentAdGroup || pageContext.CurrentAdGroup;
  this.currentCampaign = currentCampaign || pageContext.CurrentCampaign;
  this.callOnChangeCb = callOnChangeCb;
  this.supportCashbackSettings = ko.observable(!!supportCashbackSettings);
  this.hideUseCampaignSetting = ko.observable(hideUseCampaignSetting);
  this.hideAdScheduleBidAdjustments = ko.observable(hideAdScheduleBidAdjustments || false);
  this.readOnlyTimeZone = ko.observable(readOnlyTimeZone || false);
  this.showWarning = ko.computed(function () {
    return !hideWarning && !this.hideAdScheduleBidAdjustments();
  }, this);
  koSchema.properties(this);
  this.timeDisplayType = ko.observable('12-hour');
  preferencesService.initialize().then((function () {
    var preference = preferencesService.findByName('WebApp.CampaignUI.isTwelveHourDisplay');
    var isTwelveHourDisplay = preference && preference.Data;
    this.timeDisplayType(_.isUndefined(isTwelveHourDisplay) || isTwelveHourDisplay ? '12-hour' : '24-hour');
  }).bind(this));
  this.timeDisplayTypeEdit = ko.computed({
    read: function () {
      return this.timeDisplayType();
    },
    write: function (value) {
      this.timeDisplayType(value);
      preferencesService.setAtUserLevel({
        Name: 'WebApp.CampaignUI.isTwelveHourDisplay',
        Data: value === '12-hour'
      });
      callOnChangeCb();
    }
  }, this);
  var _dayOptions = adSchedulingOptions.dayOptions;
  var _hourOptions = adSchedulingOptions.hourOptions;
  _.each(_hourOptions, function (hourOption) {
    hourOption.twentyFourHourDisplay = hourOption.val < 10 ? '0' + hourOption.val : hourOption.val.toString();
    hourOption.optionsText = ko.computed(function () {
      return this.timeDisplayType() === '12-hour' ? hourOption.twelveHourDisplay : hourOption.twentyFourHourDisplay;
    }, this);
  }, this);
  var _minuteOptions = adSchedulingOptions.minuteOptions;
  var _bidAdjustmentOptions = adSchedulingOptions.bidAdjustmentOptions;
  var _bidAdjustmentRange = adSchedulingOptions.bidAdjustmentRange;
  var _minuteToSaveMap = adSchedulingOptions.minuteToSaveMap;
  var getMinuteOfTheDay = function (hour, minute) {
    return hour * 60 + _minuteToSaveMap[minute];
  };
  var isDateOverlap = function (dt1, dt2) {
    if (dt1.Day !== dt2.Day) {
      return false;
    }
    var startTime1 = getMinuteOfTheDay(dt1.StartHour, dt1.StartMinute);
    var endTime1 = getMinuteOfTheDay(dt1.EndHour, dt1.EndMinute);
    var startTime2 = getMinuteOfTheDay(dt2.StartHour, dt2.StartMinute);
    var endTime2 = getMinuteOfTheDay(dt2.EndHour, dt2.EndMinute);
    return !(startTime1 >= endTime2 || endTime1 <= startTime2);
  };
  var hourSettingIsValid = function (startHour, startMinute, endHour, endMinute) {
    return startHour < endHour || startHour === endHour && _minuteToSaveMap[startMinute] < _minuteToSaveMap[endMinute];
  };
  var self = this;
  this.conditionScheduleError = function () {
    if (this.EndHour() === 24 && this.EndMinute() !== 'ZERO') {
      return adSchedulingOptions.errors.endTimeBeyondEOD;
    }
    if (!hourSettingIsValid(this.StartHour(), this.StartMinute(), this.EndHour(), this.EndMinute())) {
      return adSchedulingOptions.errors.startTimeEarlierThanEndTime;
    }
    var bidAdjustValue = this.BidAdjustmentAmount();
    var bidAdjustment = calculateBidAdjustment(this.BidAdjustmentType(), bidAdjustValue);
    if (bidAdjustment && (bidAdjustment > _bidAdjustmentRange.maxBid || bidAdjustment < _bidAdjustmentRange.minBid)) {
      return adSchedulingOptions.errors.bidExceedLimitation;
    }
    if (_.size(bidAdjustValue.toString()) === 0) {
      return adSchedulingOptions.errors.bidEmpty;
    }
    if (!_.isFinite(bidAdjustValue) || parseInt(bidAdjustValue) !== Number(bidAdjustValue)) {
      return adSchedulingOptions.errors.bidIncorrectFormat;
    }
    var cashbackPercent = this.CashbackPercent();
    if (self.supportCashbackSettings() && !bidAdjustmentUtils.isCashbackPercentValid(cashbackPercent, decimal)) {
      return {
        message: bidAdjustmentUtils.getCashbackPercentValidationError(cashbackPercent, i18n, decimal),
        type: 'ERROR_CASHBACK_PERCENT'
      };
    }
    return '';
  };
  this.conditionDayTimeEditable = function () {
    return !_.isFinite(this.Id);
  };
  this.level = ko.observable(level === 'adgroup' ? level : 'campaign');
  this.useCampaignSettingsChecked = ko.observable(!this.hideUseCampaignSetting());
  this.useCampaignSettings = ko.computed(function () {
    return !this.hideAdScheduleBidAdjustments() && (this.level() === 'adgroup' && this.useCampaignSettingsChecked());
  }, this);
  this.showAdGroupOverrideInformation = ko.observable(false);
  this.dayOptions = ko.observableArray(_dayOptions);
  this.fromHourOptions = ko.observableArray(_hourOptions.slice(0, 24));
  this.toHourOptions = ko.observableArray(_hourOptions);
  this.minuteOptions = ko.observableArray(_minuteOptions);
  this.bidAdjustmentOptions = ko.observableArray(_bidAdjustmentOptions);
  this.dayTimeRanges = ko.observableArray([]);
  this.campaignDayTimeRanges = ko.observableArray([]);
  if (_.isEmpty(campaignDayTimeRanges)) {
    this.campaignDayTimeRanges([produceDayTimeObservable.call(this, callOnChangeCb, {
      Day: 'AllDays'
    }, true)]);
  } else {
    this.campaignDayTimeRanges(_.map(campaignDayTimeRanges, (function (range) {
      return produceDayTimeObservable.call(this, callOnChangeCb, range, true);
    }).bind(this)));
  }
  this.update(this.model);
  this.schedulingRowsErrorMessage = ko.computed(function () {
    var ranges = convertDayTimeRanges(this.dayTimeRanges(), false, this.supportCashbackSettings());
    var dayCounters = {
      'Sunday': 0,
      'Monday': 0,
      'Tuesday': 0,
      'Wednesday': 0,
      'Thursday': 0,
      'Friday': 0,
      'Saturday': 0
    };
    for (var i = 0, len = ranges.length; i < len; i++) {
      var curDt = ranges[i];
      if (++dayCounters[curDt.Day] > 7) {
        return i18n.get('ImprovedAdScheduling_CannotHaveMoreThanSevenPerDay');
      }
      for (var j = i + 1; j < len; j++) {
        var otherDt = ranges[j];
        if (isDateOverlap(curDt, otherDt)) {
          return i18n.get('ImprovedAdScheduling_Overlapping_Schedule');
        }
      }
    }
    return '';
  }, this).extend({
    notify: 'always'
  });
  this.schedulingRowsErrorMessage.subscribe(() => {
    callOnChangeCb();
  });
  this.hasErrors = ko.computed(function () {
    var isValid = true;
    if (this.hideAdScheduleBidAdjustments()) {
      isValid = isValid && _.isEmpty(this.errors());
      return !isValid;
    }
    this.dayTimeRanges().forEach(function (range) {
      if (!_.isEmpty(range().scheduleInRowError())) {
        isValid = false;
      }
    });
    isValid = isValid && _.isEmpty(this.schedulingRowsErrorMessage()) && _.isEmpty(this.errors());
    return !isValid;
  }, this);
  this.onRemovingSchedulingRow = function (index) {
    this.dayTimeRanges.splice(index, 1);
  };
  this.addTimeRow = function () {
    this.dayTimeRanges.push(produceDayTimeObservable.apply(this, [callOnChangeCb]));
  };
  this.timeZoneText = this.model.timeZoneText;
  this.adScheduleUseSearcherTimeZone = ko.observable(this.useCampaignSettings() ? !!this.model.campaignAdScheduleUseSearcherTimeZone : this.model.adScheduleUseSearcherTimeZone);
  this.adScheduleUseSearcherTimeZoneEdit = ko.computed({
    read: function () {
      return this.adScheduleUseSearcherTimeZone().toString();
    },
    write: function (value) {
      this.adScheduleUseSearcherTimeZone(value === 'true');
      callOnChangeCb();
    }
  }, this);
  this.disableAdScheduleTimeZoneEdit = ko.computed(function () {
    return this.useCampaignSettings() || this.readOnlyTimeZone();
  }, this);
};
ViewModel.prototype.validate = function () {
  var isValid = true;
  if (this.hideAdScheduleBidAdjustments()) {
    return isValid;
  }
  this.dayTimeRanges().forEach(function (range) {
    if (!_.isEmpty(range().scheduleInRowError())) {
      isValid = false;
    }
  });
  isValid = isValid && _.isEmpty(this.schedulingRowsErrorMessage());
  if (!isValid && this.activityLogger) {
    this.activityLogger.signal('schedule is not valid', 'ad schedule');
  }
  return isValid;
};
ViewModel.prototype.getCriterions = function () {
  var _minuteToSaveMap = adSchedulingOptions.minuteToSaveMap;
  var dayTimeRanges = convertDayTimeRanges(this.dayTimeRanges(), this.level() === 'campaign', this.supportCashbackSettings());
  var self = this;
  return _.map(this.useCampaignSettings() ? [] : dayTimeRanges, function (range) {
    return {
      CashbackPercent: self.supportCashbackSettings() ? bidAdjustmentUtils.getRealCashbackPercentValue(range.CashbackPercent, decimal) : undefined,
      BidAdjustment: calculateBidAdjustment(range.BidAdjustmentType, range.BidAdjustmentAmount),
      DayTimeCriterion: {
        Id: range.Id,
        Day: range.Day,
        FromHour: range.StartHour,
        FromMinute: _minuteToSaveMap[range.StartMinute],
        ToHour: range.EndHour,
        ToMinute: _minuteToSaveMap[range.EndMinute]
      },
      Type: 'DayTime'
    };
  });
};
ViewModel.prototype.getDeletedItems = function () {
  var _minuteToSaveMap = adSchedulingOptions.minuteToSaveMap, currentIds = [], deletedItems = [];
  _.each(this.dayTimeRanges(), function (range) {
    var currentId = range().Id;
    if (_.isFinite(currentId)) {
      currentIds.push(currentId);
    }
  });
  _.each(this.model.dayTimeRanges, function (range) {
    if (_.isFinite(range.Id) && _.indexOf(currentIds, range.Id) == -1) {
      deletedItems.push(range);
    }
  });
  var self = this;
  return _.map(deletedItems, function (item) {
    return {
      BidAdjustment: calculateBidAdjustment(item.BidAdjustmentType, item.BidAdjustmentAmount),
      CashbackPercent: self.supportCashbackSettings() ? bidAdjustmentUtils.getRealCashbackPercentValue(item.CashbackPercent, decimal) : undefined,
      DayTimeCriterion: {
        Id: item.Id,
        Day: item.Day,
        FromHour: item.StartHour,
        FromMinute: _minuteToSaveMap[item.StartMinute],
        ToHour: item.EndHour,
        ToMinute: _minuteToSaveMap[item.EndMinute]
      },
      Type: 'DayTime'
    };
  });
};
ViewModel.prototype.update = function (model) {
  this.model = _.extend(this.model, model);
  if (_.isEmpty(this.model.dayTimeRanges)) {
    this.dayTimeRanges([produceDayTimeObservable.call(this, this.callOnChangeCb, {
      Day: 'AllDays'
    })]);
  } else {
    this.useCampaignSettingsChecked(false);
    this.dayTimeRanges(_.map(model.dayTimeRanges, (function (range) {
      return produceDayTimeObservable.call(this, this.callOnChangeCb, range);
    }).bind(this)));
  }
};
ViewModel.prototype.getConvertedDayTimeRanges = function (ignoreDefaultRange) {
  return convertDayTimeRanges(this.dayTimeRanges(), ignoreDefaultRange, this.supportCashbackSettings());
};
ViewModel.prototype.resetCashbackInheritStatus = function (inheritInfo) {
  var dayTimeRanges = this.dayTimeRanges();
  var campaignDayTimeRanges = this.campaignDayTimeRanges();
  var self = this;
  if (inheritInfo != null) {
    var newInheritCashbackPercent = inheritInfo.value;
    var newInheritLevel = inheritInfo.level;
    if (newInheritLevel === 'AdGroup') {
      self.currentAdGroup = _.extend({}, self.currentAdGroup, {
        AdGroupCashback: _.extend({}, self.currentAdGroup ? self.currentAdGroup.AdGroupCashback : {}, {
          Percent: newInheritCashbackPercent
        })
      });
    } else if (newInheritLevel === 'Campaign') {
      self.currentCampaign = _.extend({}, self.currentCampaign, {
        CampaignCashback: _.extend({}, self.currentCampaign ? self.currentCampaign.CampaignCashback : {}, {
          Percent: newInheritCashbackPercent
        })
      });
    }
  }
  _.forEach(dayTimeRanges, function (range) {
    var cashbackPercentInheritInfo = bidAdjustmentUtils.getCashbackInheritOptions({
      readonly: false,
      CashbackPercent: range.CashbackPercent,
      viewContext: {
        currentAdGroup: self.currentAdGroup,
        currentCampaign: self.currentCampaign
      },
      i18n: i18n
    });
    var newInheritValue = cashbackPercentInheritInfo.inheritValue === '-' ? '-' : decimal.fromFloatToString(cashbackPercentInheritInfo.inheritValue, 2);
    range().InheritCashbackPercentValue(newInheritValue);
    range().CashbackPercentOptions(cashbackPercentInheritInfo.options);
  });
  _.forEach(campaignDayTimeRanges, function (range) {
    var cashbackPercentInheritInfo = bidAdjustmentUtils.getCashbackInheritOptions({
      readonly: true,
      CashbackPercent: range.CashbackPercent,
      viewContext: {
        currentAdGroup: self.currentAdGroup,
        currentCampaign: self.currentCampaign
      },
      i18n: i18n
    });
    var newInheritValue = cashbackPercentInheritInfo.inheritValue === '-' ? '-' : decimal.fromFloatToString(cashbackPercentInheritInfo.inheritValue, 2);
    range().InheritCashbackPercentValue(newInheritValue);
    range().CashbackPercentOptions(cashbackPercentInheritInfo.options);
  });
};
export default ViewModel;

